import { useState } from "react";
import { useSelector } from "react-redux";

import api from "../../api/api";
import NotesImportSuccessPopup from "../Modals/notesImportSuccessPopup";
import { addClickRecord, getCaseId, getClientId } from "../../Utils/helper";

// U2024/31/5/3:19AM
export const NotesImportPopup = ({ showImportPopup, handleClose }) => {
  const [file, setFile] = useState(null);
  const [success, setSuccess] = useState(false);
  const [result, setResult] = useState([]);
  const currentCase = getCaseId();
  const client = getClientId();
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  function successCloseClickHandler() {
    setFile(null);
    setResult([]);
    setSuccess(false);
    handleClose();
  }
  function handleFileChange(event) {
    const fileInput = event.target;
    const selectedFile = fileInput.files[0];

    if (selectedFile) {
      const fileName = selectedFile.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();

      if (fileExtension !== "csv") {
        alert("Please upload a CSV file.");
        fileInput.value = null; // Reset the input value
        setFile(null);
      } else {
        setFile(selectedFile);
      }
    }
  }
  const handleSubmit = async () => {
    const field = document.getElementById("csv-field");
    if (!file) {
      alert("Please select a file to upload.");
      return;
    }
    addClickRecord(999, page_id_click_record);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("case_id", currentCase);
    formData.append("client_id", client);
    setFile(null);
    try {
      const response = await api.post("/api/notes_csv/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      field.value = null;
      setResult(response?.data?.existing_notes);
      setSuccess(!success);
    } catch (error) {
      console.error("Error uploading file:", error);
      field.value = null;
      alert("Error while uploading file.");
      handleClose();
    }
  };
  return success ? (
    <NotesImportSuccessPopup
      showImportPopup={showImportPopup}
      closeClickHandler={successCloseClickHandler}
      result={result}
    />
  ) : (
    <>
      <div
        className={`modal generic-popup fade bd-example-modal-md ${showImportPopup ? "show" : ""}`}
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 100000,
          display: showImportPopup ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="modal-dialog" style={{ display: "flex", justifyContent: "center" }}>
          <div className="modal-content">
            <div className="modal-body">
              <div className="row align-items-center mb-3 justify-content-center">
                <div className="col-md-2 d-flex justify-content-between align-items-center CSV-textWrap mt-1">
                  <label for="uploaded_csv">Upload the file</label>
                </div>
                <div className="col-md-10 d-flex justify-content-between align-items-center">
                  <input
                    type="file"
                    style={{ paddingBottom: "33px" }}
                    id="csv-field"
                    onChange={handleFileChange}
                    className="form-control choose-file-csv"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary float-left-margin-right-auto"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button type="button" onClick={handleSubmit} className="btn btn-success">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NotesImportPopup;
